export const breakpoints = {
  sm: 768,
  md: 1025,
  lg: 1440,
}
export const MEDIA_SM_TABLET = `@media (min-width: ${breakpoints.sm}px)`
export const MEDIA_MD_LAPTOP = `@media (min-width: ${breakpoints.md}px)`
export const MEDIA_LG_DESKTOP = `@media (min-width: ${breakpoints.lg}px)`
